import React, { useState } from 'react'
import { Row, Col, Container, Button, Spinner } from "reactstrap";
import img from "../../../assets/images/logo.png"
import { RiArrowLeftLine, RiFileChartLine } from "react-icons/ri";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { trackDownload } from "../../../services/activityTracker";
import VulnerabilityTable from './VulnerabilityTable';
import VulnerabilityChartTables from './VulnerabilityChartTables';
import Recommendation from './Recommendation';
import { useNavigate } from 'react-router-dom';

const ORANGE_COLORS = {
    primary: '#FF5B00',
    dark:    '#e85a28',
};

function Index() {
    const navigate     = useNavigate();
    const [pdfLoading, setPdfLoading] = useState(false);

    const downloadPDF = async () => {
        setPdfLoading(true);
        try {
            const pdf       = new jsPDF("p", "mm", "a4");
            const pageWidth = pdf.internal.pageSize.getWidth();

            const section1  = document.getElementById("Page1");
            const canvas1   = await html2canvas(section1, { scale: 2 });
            const imgData1  = canvas1.toDataURL("image/png", 1.0);
            const imgHeight1 = (canvas1.height * pageWidth) / canvas1.width;
            pdf.addImage(imgData1, "PNG", 0, 0, pageWidth, imgHeight1);

            pdf.addPage();

            const section2  = document.getElementById("Page2");
            const canvas2   = await html2canvas(section2, { scale: 2 });
            const imgData2  = canvas2.toDataURL("image/png", 1.0);
            const imgHeight2 = (canvas2.height * pageWidth) / canvas2.width;
            pdf.addImage(imgData2, "PNG", 0, 0, pageWidth, imgHeight2);

            pdf.save("Vulnerability Report.pdf");
            trackDownload("Vulnerability Report PDF");
        } finally {
            setPdfLoading(false);
        }
    };

    return (
        <div className="page-content px-4 pt-4 mt-5 mb-4" style={{ backgroundColor: "#ffffff", color: "#000000", padding: "20px" }}>
            <Container fluid>

                {/* ── Toolbar ── */}
                <Row className="mt-1 mb-3 align-items-center">
                    <Col>
                        <Button
                            onClick={() => navigate(-1)}
                            style={{
                                backgroundColor: "transparent",
                                border: "1px solid rgba(0,0,0,0.15)",
                                color: "#555",
                                borderRadius: "8px",
                                fontSize: "13px",
                                fontWeight: 500,
                                padding: "7px 14px",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                            }}
                        >
                            <RiArrowLeftLine size={15} />
                            Back to Reports
                        </Button>
                    </Col>
                    <Col className="text-end d-flex justify-content-end">
                        <Button
                            onClick={downloadPDF}
                            disabled={pdfLoading}
                            style={{
                                backgroundColor: ORANGE_COLORS.primary,
                                border: "none",
                                color: "#fff",
                                borderRadius: "8px",
                                fontSize: "13px",
                                fontWeight: 500,
                                padding: "7px 14px",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                            }}
                        >
                            {pdfLoading
                                ? <><Spinner size="sm" /> Generating…</>
                                : <><RiFileChartLine size={15} /> Download PDF</>
                            }
                        </Button>
                    </Col>
                </Row>

                {/* ── Printable report area (unchanged) ── */}
                <div id="VulnerabilityReport" style={{ backgroundColor: "#ffffff", color: "#000000", padding: "20px" }}>
                    <div id="Page1">
                        <Row className="align-items-center mb-4 mt-2">
                            <Col md={3} className="text-md-start text-center">
                                <img src={img} alt="Logo" style={{ width: "80px" }} />
                            </Col>
                            <Col md={6} className="text-center">
                                <h3 style={{ fontFamily: "Poppins, sans-serif" }} className="text-dark">
                                    Vulnerability Report
                                </h3>
                            </Col>
                        </Row>

                        <div className="border-0 shadow-sm mb-2">
                            <h5 className="mb-0 text-dark">Executive Summary</h5>
                            <p className="text-dark mt-2">
                                This Vulnerability Report provides a structured overview of security weaknesses identified across monitored systems and applications. It highlights the types of vulnerabilities detected, their relative severity, and the potential impact on business operations. The report is designed to give stakeholders a clear understanding of the current risk posture, outline areas requiring immediate attention, and support informed decision‑making. By combining technical findings with actionable insights, the report ensures alignment with compliance frameworks and industry best practices, while offering practical recommendations for remediation and ongoing risk management.
                            </p>
                        </div>

                        <VulnerabilityTable />
                    </div>

                    <div id="Page2">
                        <VulnerabilityChartTables />
                        <Recommendation />
                    </div>
                </div>

            </Container>
        </div>
    );
}

export default Index;